export default "__VITE_ASSET__DHigU87o__"